module.exports = __webpack_public_path__ + "img/14备份 3.88aa7b2b.jpg";